import appActionTypes from "containers/App/_actions";
import * as api from "api";
import ReactGA from "react-ga4";

const actionTypes = {
    SUBMIT_SUPPORT_REQUEST_SUCCESS: "SUBMIT_SUPPORT_REQUEST_SUCCESS",
    GET_TICKETS: "GET_TICKETS",
    GET_TICKETS_SUCCESS: "GET_TICKETS_SUCCESS",
    ADD_TICKET_COMMENT_SUCCESS: "ADD_TICKET_COMMENT_SUCCESS",
    OPEN_SUPPORT_MODAL: "OPEN_SUPPORT_MODAL",
    CLOSE_SUPPORT_MODAL: "CLOSE_SUPPORT_MODAL",
};

export default actionTypes;

export function submitRequest(request, onSuccess) {
    ReactGA.event({
        category: "Support",
        action: "Create Ticket",
    });
    return api.post({
        path: `support/request`,
        content: request,
        onSuccess: (response) => {
            return (dispatch) => {
                dispatch({ type: actionTypes.SUBMIT_SUPPORT_REQUEST_SUCCESS, payload: request });
                onSuccess();
            };
        },
        onFailure: (error) => {
            error.handled = true;
            return (dispatch) => {
                switch (error.status) {
                    default:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: "An unexpected error has occured. Please try again or call support if the problem persists." });
                        break;
                }
            };
        },
    });
}

export function getTickets() {
    ReactGA.event({
        category: "Support",
        action: "Get Tickets",
    });
    return api.get({
        path: `support/tickets`,
        onSuccess: (response) => {
            return (dispatch) => {
                dispatch({ type: actionTypes.GET_TICKETS_SUCCESS, payload: response });
            };
        },
        onFailure: (error) => {
            error.handled = true;
            return (dispatch) => {
                switch (error.status) {
                    default:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: "An unexpected error has occured while retrieving existing tickets. Please try again or call support if the problem persists." });
                        break;
                }
            };
        },
    });
}

export function addTicketComment(id, comment, onSuccess) {
    ReactGA.event({
        category: "Support",
        action: "Add Ticket Comment",
    });
    return api.post({
        path: `support/tickets/${id}/comments`,
        content: {
            ticketId: id,
            comment,
        },
        onSuccess: (response) => {
            return (dispatch) => {
                dispatch(getTickets());
                onSuccess();
            };
        },
        onFailure: (error) => {
            error.handled = true;
            return (dispatch) => {
                switch (error.status) {
                    default:
                        dispatch({ type: appActionTypes.APP_MODAL_ERROR, payload: "An unexpected error has occured while retrieving existing tickets. Please try again or call support if the problem persists." });
                        break;
                }
            };
        },
    });
}

export function openSupportModal(name) {
    return { type: actionTypes.OPEN_SUPPORT_MODAL, payload: name };
}

export function closeSupportModal(name) {
    return { type: actionTypes.CLOSE_SUPPORT_MODAL };
}
